module.exports = __webpack_public_path__ + "img/adicionar-white.1be4da6c.png";